import type { RendererElement, RendererNode, VNode } from 'vue';
import { createVNode, render } from 'vue';
import Loading from './index.vue';

let container: HTMLDivElement | null = null;
let vm: VNode<RendererNode, RendererElement, { [key: string]: any }> | null = null;

export function useLoading() {
  function close() {
    if ((vm?.component?.props as any)?.show) {
      (vm?.component?.props as any).show = false;
    }
  }

  function open(toastText?: string) {
    if (container && vm) {
      return;
    }

    container = document.createElement('div');
    vm = createVNode(
      Loading,
      {
        onClose: close,
        afterLeave: () => {
          if (container) {
            document.body.removeChild(container);
            container = null;
            vm = null;
          }
        },
        onShow: () => {
          (vm?.component?.props as any).show = true;
        },
        show: false,
        toastText,
      },
    );

    render(vm, container);
    document.body.appendChild(container);
  }

  return {
    open,
    close,
  };
}
